import { createApiSelectors } from 'reacticoon/selector'

export const fetchSearchSelectors = createApiSelectors('App::SearchModule')
